<template>
  <div class="header-box">
    <div class="center-box">
      <div class="header-left">呼吸联合体账户中心</div>
      <template v-if="common_token">
        <!-- 已登录 -->
        <el-dropdown @command="handleCommand">
          <div class="header-right">
            <template v-if="avatar">
              <img :src="avatar" class="header-avatar" />
            </template>
            <template v-else>
              <img src="~@/images/user_avatar.png" class="header-avatar" />
            </template>
            <div class="header-name">欢迎，{{ name }}</div>
          </div>
          <el-dropdown-menu slot="dropdown" style="width: 200px">
            <el-dropdown-item command="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { clearToken } from "@/utils/auth";
export default {
  name: "Header",
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["common_token", "avatar", "name"]),
  },
  mounted() {},
  methods: {
    ...mapMutations("user", ["CLEAR_DATA"]),
    handleCommand(command) {
      if (command === "exit") {
        this["CLEAR_DATA"]();
        clearToken();
        this.$router.replace({
          name: "Login",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
